'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/tags", "/tags/list");

  $stateProvider
    .state('tags', {
      url: '/tags',
      template: require('./tags.html'),
      authenticate: true
    })
    .state('tags.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'TagsListController',
      controllerAs: 'tagsListCtrl'
    })
    .state('tags.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'TagsEditController',
      controllerAs: 'tagsEditCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/tags/tags.routes.js